// Pages en allemand. translationOf : page française équivalente, pour les
// balises hreflang et le lien de changement de langue.
import { AREAS } from './site';
import leakPhoto from '../assets/dde.webp';
import gazImg from '../assets/gaz_traceur_detecteur.webp';
import thermoImg from '../assets/thermographie_chauffage_sol.webp';
import inspectionImg from '../assets/inspection_camera_egout.webp';
import fluoresceineImg from '../assets/fluoresceine_uv.webp';
import humidimetreImg from '../assets/humidimetre_mur.webp';

const LEAK_TYPES = [
  '[Unterputz- und Erdleitungen](/de/leckortung-wasserleitung): in einer Bodenplatte, einer Wand, unter dem Garten.',
  '[Heizung und Fußbodenheizung](/de/leckortung-heizung): Heizkessel, der Druck verliert, Heizkörper, Heizkreise im Estrich.',
  '[Abwasser und Kanal](/de/leckortung-abwasser): Fallrohre, Anschlüsse, erdverlegte Leitungen, Kanalgeruch.',
  '[Duschen, Badewannen und Lecks unter Fliesen](/de/leckortung-dusche): Zuleitung, Ablauf oder Abdichtung.',
  '[Eindringendes Wasser](/de/ortung-wassereintritt): Dach, Terrasse, Fassade, Keller.',
  '[Erhöhter Wasserverbrauch](/de/hoher-wasserverbrauch): Zähler, der sich dreht, auffällige Rechnung, Leck ohne sichtbare Spuren.',
];

const PARENT = '/de/leckortung-luxemburg';

export const pagesDe = [
  {
    path: '/de/leckortung-luxemburg',
    lang: 'de',
    translationOf: '/recherche-fuite-luxembourg',
    nav: 'Leckortung in Luxemburg',
    summary: 'Zerstörungsfreie Ortung von Wasserlecks und Feuchtigkeitsschäden im ganzen Großherzogtum, Bericht innerhalb von 72 Stunden.',
    title: 'Leckortung Luxemburg | Zerstörungsfreie Lecksuche | Expomis',
    description: 'Zerstörungsfreie Leckortung im ganzen Großherzogtum Luxemburg: Wasserleitungen, Heizung, Abwasser, eindringendes Wasser. Bericht innerhalb von 72 Stunden.',
    eyebrow: 'Großherzogtum Luxemburg',
    h1: 'Leckortung in Luxemburg',
    serviceType: 'Leckortung',
    image: leakPhoto,
    imageAlt: 'Wasserleck an einer Kupferleitung',
    areaServed: AREAS.lu,
    intro: [
      'Expomis ortet Wasserlecks ohne Abriss im ganzen Großherzogtum Luxemburg, von unserem Büro in Steinfort aus. Unterputzleitung, Fußbodenheizung, Abwasserleitung, Dusche, eindringendes Wasser über Dach oder Fassade: Wir finden die Ursache des Lecks, bestimmen seine genaue Lage und übergeben Ihnen innerhalb von 72 Stunden einen Bericht, den Sie bei Ihrer Versicherung einreichen können.',
      'Wir sind außerdem Schadensgutachter. Über das Leck hinaus wissen wir, was Ihre Versicherung braucht, um einen [Wasserschaden](/de/wasserschaden) zu bearbeiten.',
    ],
    sections: [
      {
        h2: 'Wann ist eine Leckortung sinnvoll?',
        body: ['Ein verdecktes Leck sieht man selten direkt. Man sieht seine Folgen:'],
        list: [
          'ein Feuchtigkeitsfleck, der sich an der Decke oder an einer Wand ausbreitet;',
          'ein Wasserzähler, der sich dreht, obwohl alles geschlossen ist, oder eine ungewöhnlich hohe Wasserrechnung;',
          'eine Heizung, die Druck verliert und regelmäßig nachgefüllt werden muss;',
          'Farbe, die Blasen wirft, Fugen, die schwarz werden, Modergeruch;',
          'Fliesen, die sich lösen, Parkett, das aufquillt;',
          'Wasser, das beim Nachbarn darunter auftaucht.',
        ],
        after: [
          'Je länger ein Leck besteht, desto größer wird der Schaden: durchnässte Baustoffe, Schimmel, manchmal Schäden an der Bausubstanz. Eine schnelle Ortung senkt auch die Reparaturkosten.',
        ],
      },
      {
        h2: 'Zerstörungsfreie Leckortung: was das bedeutet',
        body: [
          'Zerstörungsfrei heißt nicht, dass nie geöffnet werden muss: Die Leitung muss ja repariert werden. Es heißt, dass das Leck geortet wird, ohne aufs Geratewohl aufzustemmen. Statt eine ganze Wand aufzubrechen oder das ganze Bad zu erneuern, wird nur an der Stelle geöffnet, die wir markiert haben, und nur auf kleiner Fläche.',
        ],
      },
      {
        h2: 'Welche Lecks wir orten',
        list: LEAK_TYPES,
      },
      {
        h2: 'Unsere Ortungsverfahren',
        body: [
          'Kein Verfahren funktioniert in allen Fällen. Die Wahl hängt vom Leitungsnetz ab (Kaltwasser, Warmwasser, Heizung, Abwasser), von seinem Druck und von den Baustoffen, die es bedecken. Oft kombinieren wir mehrere Verfahren, um die Ergebnisse abzusichern.',
        ],
        list: [
          '[Feuchtigkeitsmessung](/de/leckortung-verfahren/feuchtigkeitsmessung), um die betroffene Zone einzugrenzen;',
          '[Druckprüfung](/de/leckortung-verfahren/druckpruefung), um das Leck zu bestätigen und den betroffenen Kreislauf zu bestimmen;',
          '[Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera) für Warmwasser und Fußbodenheizung;',
          '[akustische Ortung](/de/leckortung-verfahren/akustische-ortung) für Leitungen unter Druck;',
          '[Tracergas](/de/leckortung-verfahren/tracergas) für kleine, erdverlegte oder unter dem Estrich liegende Lecks;',
          '[Fluoreszein](/de/leckortung-verfahren/fluoreszein), [Rauchtest](/de/leckortung-verfahren/rauchtest) und [Kanalkamera](/de/leckortung-verfahren/kanalkamera) für Abwasserleitungen;',
          '[Endoskopie](/de/leckortung-verfahren/endoskopie), um in unzugängliche Bereiche zu sehen.',
        ],
        after: ['Wie jedes Verfahren funktioniert und wo seine Grenzen liegen: [unsere Verfahren der Leckortung](/de/leckortung-verfahren).'],
      },
      {
        h2: 'So läuft der Einsatz ab',
        ordered: true,
        list: [
          'Sie beschreiben uns die Anzeichen telefonisch oder per E-Mail, unverbindlich.',
          'Vor Ort beobachten, fotografieren und messen wir die Feuchtigkeit, um die betroffene Zone einzugrenzen.',
          'Wir prüfen die Kreisläufe unter Druck, um zu wissen, welcher undicht ist, und orten dann die Leckstelle mit dem passenden Verfahren.',
          'Die Lage des Lecks wird vor Ort markiert.',
          'Innerhalb von 72 Stunden erhalten Sie einen vollständigen Bericht mit Fotos und Messwerten.',
        ],
      },
      {
        h2: 'Leckortung und Versicherung',
        body: [
          'In Luxemburg übernehmen viele Gebäude- und Hausratversicherungen die Kosten der Leckortung, wenn das Leck einen Wasserschaden verursacht hat. Die Bedingungen sind von Vertrag zu Vertrag verschieden: Prüfen Sie Ihre Unterlagen oder fragen Sie Ihren Versicherungsagenten. Wer wofür zahlt, hängt auch davon ab, wo das Leck liegt: siehe unseren Ratgeber [Wasserschaden in Luxemburg: Wer zahlt?](/de/wasserschaden-wer-zahlt).',
          'Unser Bericht beschreibt die Feststellungen, die eingesetzten Verfahren, die ermittelte Ursache und die festgestellten Schäden: Das ist das Dokument, das die Versicherung zur Bearbeitung des Schadens erwartet. Und wenn Sie der Meinung sind, dass die Bewertung des Gutachters Ihrer Versicherung nicht der Wirklichkeit entspricht, können wir als unabhängiger Gegengutachter tätig werden.',
        ],
      },
      {
        h2: 'Wo sind wir im Einsatz?',
        body: [
          'Im ganzen Großherzogtum: [Luxemburg-Stadt](/de/leckortung-luxemburg-stadt), Esch an der Alzette, Differdingen, Düdelingen, Petingen, Sassenheim, Mamer, Strassen, Bartringen, Hesperingen, Capellen, Mersch, Ettelbrück, Diekirch, Wiltz, Grevenmacher, Remich, Echternach und alle anderen Gemeinden.',
          'Von Steinfort aus, an der belgischen Grenze, sind wir auch regelmäßig im Süden der belgischen Provinz Luxemburg tätig.',
        ],
      },
    ],
    faq: [
      {
        q: 'Was kostet eine Leckortung in Luxemburg?',
        a: 'Jede Leckortung wird pro Leistung abgerechnet, zu einem Preis, der vor dem Einsatz mit Ihnen festgelegt wird; wird das Leck bei einem einzigen Besuch ohne Abbau gefunden, gilt eine Pauschale, wenn sie günstiger ist. Der Preis hängt von der Art des Lecks, vom Umfang des zu prüfenden Leitungsnetzes und von den nötigen Verfahren ab. In vielen Fällen übernimmt die Versicherung die Kosten. Siehe [Kosten einer Leckortung](/de/leckortung-kosten).',
      },
      {
        q: 'Muss für die Leckortung aufgestemmt werden?',
        a: 'Nein. Die Ortung erfolgt ohne Abriss. Für die Reparatur muss geöffnet werden, aber nur an der genauen Stelle des Lecks.',
      },
      {
        q: 'Was tun, bis Sie kommen?',
        a: 'Bei einem größeren Leck den Hauptwasserhahn schließen. Den Strom in den betroffenen Räumen abschalten, wenn das Wasser elektrischen Anlagen nahekommt. Die Schäden fotografieren und die Versicherung informieren. Die Installation möglichst nicht abbauen oder verändern: Das erschwert die Ortung.',
      },
      {
        q: 'Wann erhalte ich den Bericht?',
        a: 'Innerhalb von 72 Stunden. Er enthält Fotos und Messwerte und kann unverändert an Ihre Versicherung weitergeleitet werden.',
      },
      {
        q: 'Kommen Sie auch im Notfall?',
        a: 'Ja, ein Notdienst ist rund um die Uhr unter +352 661 181 082 erreichbar.',
      },
    ],
    related: ['/de/wasserschaden', '/de/wasserschaden-wer-zahlt', '/de/leckortung-wasserleitung'],
  },
  {
    path: '/de/leckortung-luxemburg-stadt',
    lang: 'de',
    translationOf: '/recherche-fuite-luxembourg-ville',
    parent: PARENT,
    nav: 'Leckortung in Luxemburg-Stadt',
    summary: 'Wohnungen in Miteigentum, Stadthäuser und Altbauten, von der Oberstadt bis zum Kirchberg.',
    title: 'Leckortung Luxemburg-Stadt | Ohne Aufstemmen | Expomis',
    description: 'Zerstörungsfreie Leckortung in Luxemburg-Stadt: Wohnungen in Miteigentum, Leck beim Nachbarn, Tiefgaragen, Altbauten. Bericht innerhalb von 72 Stunden.',
    eyebrow: 'Luxemburg-Stadt',
    h1: 'Leckortung in Luxemburg-Stadt',
    serviceType: 'Leckortung',
    areaServed: [{ '@type': 'City', name: 'Luxembourg' }],
    intro: [
      'Expomis ortet Wasserlecks und eindringendes Wasser ohne Abriss in allen Vierteln von Luxemburg-Stadt: Oberstadt, Bahnhofsviertel, Bonneweg, Limpertsberg, Belair, Merl, Hollerich, Gasperich, Zessingen, Kirchberg, Neudorf, Cents, Clausen, Grund, Pfaffenthal und alle anderen.',
      'Sie erhalten innerhalb von 72 Stunden einen Bericht, der die Ursache des Lecks feststellt: das Dokument, das Versicherung, Hausverwaltung oder Vermieter verlangen.',
    ],
    sections: [
      {
        h2: 'In der Wohnung: Aus welcher Wohnung kommt das Leck?',
        body: [
          'In Luxemburg-Stadt sind viele Wohnungen Teil eines Gebäudes in Miteigentum. Das Leck zeigt sich oft an der Decke des Nachbarn darunter, und die erste Frage ist keine technische: Wer ist betroffen? Der Nachbar darüber, der gemeinsame Steigstrang, die Dachterrasse?',
          'Wir sperren jeden Kreislauf der verdächtigen Wohnung ab und prüfen ihn unter Druck: So steht fest, ob er undicht ist oder nicht. Danach orten wir die Leckstelle. Der Bericht gibt an, ob die Ursache im Sondereigentum oder im Gemeinschaftseigentum liegt. Diese Angabe brauchen Hausverwaltung und Versicherungen, um zu klären, wer den Schaden übernimmt.',
        ],
      },
      {
        h2: 'Neuere Wohnanlagen: Fußbodenheizung, Installationsschächte, Tiefgaragen',
        body: [
          'In den Wohnanlagen der letzten Jahrzehnte, auf dem Kirchberg, in Gasperich oder an der Cloche d’Or wie anderswo in der Stadt, kehren einige Situationen immer wieder:',
        ],
        list: [
          'die [Fußbodenheizung](/de/leckortung-heizung), die Druck verliert, mit Heizkreisen im Estrich: Wir prüfen jeden Kreis am Verteiler, dann macht die [Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera) das Leck sichtbar;',
          'Leitungen in Installationsschächten und abgehängten Decken, die sich mit der [Endoskopie](/de/leckortung-verfahren/endoskopie) durch eine kleine Öffnung prüfen lassen;',
          'eindringendes Wasser in Tiefgaragen und Kellern, über erdberührte Wände, Plattenfugen oder die Dachterrasse darüber: [Fluoreszein](/de/leckortung-verfahren/fluoreszein) verbindet das austretende Wasser mit seiner Eintrittsstelle.',
        ],
      },
      {
        h2: 'Altbauten: erhalten, was sich nicht ersetzen lässt',
        body: [
          'In der Oberstadt, in Limpertsberg, in Belair oder in den Stadthäusern im Bahnhofsviertel und in Bonneweg wurden die Installationen oft bei Renovierungen verändert. Alte Abschnitte aus verzinktem Stahl, manchmal aus Blei, treffen auf Kupfer oder Mehrschichtverbundrohr, und die Übergänge zwischen diesen Werkstoffen sind häufige Leckstellen.',
          'Diese Gebäude haben auch Parkett, Stuck und alte Fliesen, die sich nicht identisch ersetzen lassen. Hier zählt die zerstörungsfreie Ortung am meisten: an der richtigen Stelle und auf kleiner Fläche öffnen, statt eine ganze Wand oder einen ganzen Boden aufzustemmen.',
        ],
      },
      {
        h2: 'In den Tälern: Leck oder Feuchtigkeit aus dem Erdreich?',
        body: [
          'Im Grund, in Clausen und im Pfaffenthal stehen die Häuser an der Alzette, oft an den Felsen gebaut. Die Kellerwände sind dort aus Gründen feucht, die nichts mit einem Leck zu tun haben: Wasser aus dem Erdreich, aufsteigende Feuchtigkeit. Bevor Arbeiten beginnen, stellen wir fest, woher das Wasser kommt: Kartierung mit der [Feuchtigkeitsmessung](/de/leckortung-verfahren/feuchtigkeitsmessung), dann Druckprüfung der Leitungen. Sind sie dicht, sagen wir es Ihnen, und der Bericht hält es fest.',
        ],
      },
      {
        h2: 'Was wir in Luxemburg-Stadt orten',
        list: LEAK_TYPES,
      },
    ],
    faq: [
      {
        q: 'Ich bin Mieter und habe ein Leck: Wer beauftragt Sie?',
        a: 'Informieren Sie zuerst Ihren Vermieter oder die Agentur sowie Ihre Versicherung. Die Leckortung kann vom Mieter, vom Vermieter oder von der Hausverwaltung beauftragt werden: Der Bericht, der die Ursache feststellt, dient anschließend dazu, zu klären, wer die Reparatur übernimmt. Die genauen Regeln hängen vom Mietvertrag und von den Versicherungsverträgen ab. Siehe unseren Ratgeber [Wasserschaden: Wer zahlt?](/de/wasserschaden-wer-zahlt).',
      },
      {
        q: 'Das Wasser kommt vom Nachbarn darüber, aber er ist nicht erreichbar. Was tun?',
        a: 'Informieren Sie die Hausverwaltung: Sie hat Zugang zum Gemeinschaftseigentum und kann den Miteigentümer kontaktieren. Um das Leck genau zu orten, brauchen wir Zugang zu der Wohnung, aus der es kommt. Fotografieren Sie in der Zwischenzeit die Schäden und melden Sie den Schaden Ihrer Versicherung.',
      },
      {
        q: 'Muss für die Leckortung aufgestemmt werden?',
        a: 'Nein. Die Ortung erfolgt ohne Abriss. Für die Reparatur muss geöffnet werden, aber nur an der Stelle, die wir markiert haben.',
      },
      {
        q: 'Wann erhalte ich den Bericht?',
        a: 'Innerhalb von 72 Stunden. Er enthält Fotos und Messwerte und kann unverändert an die Versicherung oder die Hausverwaltung weitergeleitet werden.',
      },
      {
        q: 'Kommen Sie auch im Notfall?',
        a: 'Ja, ein Notdienst ist rund um die Uhr unter +352 661 181 082 erreichbar.',
      },
    ],
    related: ['/de/leckortung-luxemburg', '/de/wasserschaden-wer-zahlt', '/de/leckortung-heizung'],
  },
  {
    path: '/de/leckortung-wasserleitung',
    lang: 'de',
    translationOf: '/recherche-fuite-canalisation',
    parent: PARENT,
    nav: 'Leck an der Wasserleitung',
    summary: 'Wasserleitung in einer Bodenplatte, einer Wand oder erdverlegt unter dem Garten.',
    title: 'Leckortung an Unterputz- und Erdleitungen | Expomis',
    description: 'Zerstörungsfreie Leckortung an Unterputz- und erdverlegten Wasserleitungen in Luxemburg: Druckprüfung, Wärmebild, akustische Ortung, Tracergas.',
    eyebrow: 'Leckarten',
    h1: 'Leckortung an Unterputz- und Erdleitungen',
    serviceType: 'Leckortung',
    image: gazImg,
    imageAlt: 'Leckortung unter Fliesen mit Tracergas, Detektor und Bodensonde',
    intro: [
      'Eine undichte Wasserleitung in einer Bodenplatte, einer Wand oder unter dem Garten sieht man nicht: Man bemerkt nur die Folgen, einen Zähler, der sich dreht, einen Feuchtigkeitsfleck, sinkenden Druck. Expomis ortet solche Lecks, ohne aufs Geratewohl zu öffnen, mit dem passenden Verfahren für die betroffene Leitung.',
    ],
    sections: [
      {
        h2: 'Anzeichen für ein Leck an der Wasserleitung',
        list: [
          'der Wasserzähler dreht sich, obwohl alle Hähne und Geräte geschlossen sind;',
          'ein Wasserfleck erscheint an der Decke, am Fuß einer Wand oder auf dem Estrich;',
          'eine Stelle am Boden ist wärmer als der Rest (Warmwasserleck);',
          'man hört ein ständiges Rauschen oder Zischen;',
          'der Druck am Wasserhahn ist ohne erkennbaren Grund gesunken.',
        ],
      },
      {
        h2: 'Erst den Kreislauf finden, dann die Leckstelle',
        body: [
          'Ein Haus hat mehrere Kreisläufe: Kaltwasser, Warmwasser, manchmal eine Zirkulationsleitung, und die Heizung. Bevor wir die Leckstelle suchen, stellen wir durch eine [Druckprüfung](/de/leckortung-verfahren/druckpruefung) Abschnitt für Abschnitt fest, in welchem Kreislauf sie liegt. Das grenzt den Suchbereich ein und vermeidet falsche Fährten.',
        ],
      },
      {
        h2: 'Wie wir das Leck orten',
        list: [
          'Warmwasserleitung: Die [Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera) zeigt den Verlauf des Rohrs und die Zone, in der sich das warme Wasser ausbreitet.',
          'Leitung unter Druck, auch Kaltwasser: Die [akustische Ortung](/de/leckortung-verfahren/akustische-ortung) erfasst das Geräusch des austretenden Wassers.',
          'Kleines, leises Leck unter einer dicken Bodenplatte oder im Erdreich: Das [Tracergas](/de/leckortung-verfahren/tracergas) steigt genau über dem Leck an die Oberfläche.',
        ],
        after: ['Oft kombinieren wir zwei Verfahren, um die Stelle zu bestätigen, bevor wir sie markieren.'],
      },
      {
        h2: 'Erdverlegte Leitungen',
        body: [
          'Die Leitung, die das Gebäude, eine Garage, ein Gartenhaus oder einen Außenwasserhahn versorgt, kann über mehrere Dutzend Meter unter Rasen oder Einfahrt verlaufen. Tracergas und akustische Ortung zeigen, wo gegraben werden muss, statt einen Graben über die ganze Länge zu ziehen.',
          'Je nach Lage des Lecks kann die Reparatur Sache des Versorgers oder der Gemeinde statt des Eigentümers sein. Die genaue Ortung zeigt auch, wer zuständig ist.',
        ],
      },
    ],
    faq: [
      {
        q: 'Mein Zähler dreht sich, obwohl alles zu ist: Ist das immer ein Leck?',
        a: 'Fast immer, außer ein Gerät verbraucht Wasser, ohne dass Sie es wissen: ein Spülkasten, der ständig nachläuft, eine Enthärtungsanlage in der Regeneration, eine tropfende Sicherheitsgruppe am Warmwasserspeicher. Prüfen Sie diese Punkte zuerst; unsere Seite [hoher Wasserverbrauch](/de/hoher-wasserverbrauch) erklärt, wie.',
      },
      {
        q: 'Muss während des Einsatzes das Wasser abgestellt werden?',
        a: 'Für manche Prüfungen ja: Druckprüfung und Tracergas erfordern es, den geprüften Abschnitt abzusperren oder sogar zu entleeren. Die Unterbrechung beschränkt sich auf die Dauer der Prüfung.',
      },
    ],
    related: ['/de/hoher-wasserverbrauch', '/de/leckortung-heizung', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/leckortung-heizung',
    lang: 'de',
    translationOf: '/recherche-fuite-chauffage',
    parent: PARENT,
    nav: 'Leck an Heizung und Fußbodenheizung',
    summary: 'Heizung verliert Druck, Fußbodenheizung, Heizkörper und Heizungsleitungen.',
    title: 'Leckortung Fußbodenheizung und Heizung | Expomis',
    description: 'Ihre Heizung verliert Druck? Leckortung an Fußbodenheizung und Heizkörpern, ohne den Estrich aufzubrechen: Prüfung je Heizkreis, Wärmebild, Tracergas.',
    eyebrow: 'Leckarten',
    h1: 'Leckortung an Heizung und Fußbodenheizung',
    serviceType: 'Leckortung',
    image: thermoImg,
    imageAlt: 'Leck an einer Fußbodenheizung, sichtbar mit der Wärmebildkamera',
    intro: [
      'Eine Heizung, die Druck verliert und regelmäßig nachgefüllt werden muss, ist das häufigste Anzeichen für ein Leck im Heizkreislauf. Bei einer Fußbodenheizung liegen die Rohre im Estrich: Das Leck ist nicht zu sehen, und den Boden aufs Geratewohl zu öffnen ist teuer. Expomis ortet das Leck genau und ohne Abriss.',
    ],
    sections: [
      {
        h2: 'Anzeichen für ein Heizungsleck',
        list: [
          'der Druck der Heizung sinkt und Sie müssen regelmäßig Wasser nachfüllen;',
          'eine Stelle am Boden ist wärmer als der Rest, oder ein Fleck erscheint an der Decke darunter;',
          'Feuchtigkeit am Fuß einer Wand oder unter einem Heizkörper;',
          'ein Bodenbelag, der sich löst, oder Parkett, das aufquillt.',
        ],
      },
      {
        h2: 'Bevor wir das Leck suchen: prüfen, ob es eines gibt',
        body: [
          'Ein Druckverlust kommt nicht immer von einem Leck im Boden. Ein Ausdehnungsgefäß ohne Vordruck oder ein Sicherheitsventil, das Wasser ablässt, verursachen dasselbe Symptom. Wir kontrollieren diese Teile und setzen dann den Kreislauf Heizkreis für Heizkreis am Verteiler unter Druck, um den undichten zu finden.',
        ],
      },
      {
        h2: 'Warum die Wärmebildkamera geeignet ist',
        body: [
          'Die Heizung ist ein warmer Kreislauf. Wenn sie aufgeheizt wird, zeigt die [Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera) den Verlauf der Rohre unter dem Belag und dann den Wärmefleck, der sich dort bildet, wo Wasser austritt. Reicht der Temperaturkontrast nicht aus (dicker Belag, kleines Leck), setzen wir [Tracergas](/de/leckortung-verfahren/tracergas) ein.',
        ],
      },
    ],
    faq: [
      {
        q: 'Meine Heizung verliert Druck: Ist das immer ein Leck?',
        a: 'Nicht unbedingt. Ein Ausdehnungsgefäß ohne Vordruck oder ein defektes Sicherheitsventil verursachen dasselbe Symptom. Sind diese Teile in Ordnung und sinkt der Druck weiter, liegt sehr wahrscheinlich ein Leck im Kreislauf vor.',
      },
      {
        q: 'Lässt sich eine Fußbodenheizung reparieren, ohne den ganzen Boden zu erneuern?',
        a: 'Ja, in den meisten Fällen. Ist das Leck geortet, wird der Estrich örtlich geöffnet, das Rohr mit einem Verbinder repariert und wieder verschlossen. Genau darin liegt der Nutzen einer präzisen Ortung.',
      },
    ],
    related: ['/de/leckortung-wasserleitung', '/de/hoher-wasserverbrauch', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/leckortung-abwasser',
    lang: 'de',
    translationOf: '/recherche-fuite-evacuation',
    parent: PARENT,
    nav: 'Leck an Abwasser und Kanal',
    summary: 'Abflüsse, Fallrohre, Anschlüsse und Kanal: Lecks, Feuchtigkeit und Kanalgeruch.',
    title: 'Leckortung Abwasser und Kanal | Rauchtest, Kamera | Expomis',
    description: 'Leckortung an Abwasserleitungen, Fallrohren und Kanal: Fluoreszein, Rauchtest, Kanalkamera. Kanalgeruch, Flecken nach Benutzung eines Geräts.',
    eyebrow: 'Leckarten',
    h1: 'Leckortung an Abwasserleitungen und Kanal',
    serviceType: 'Leckortung',
    image: inspectionImg,
    imageAlt: 'Kamerainspektion eines gerissenen Kanalrohrs aus einem Schacht',
    intro: [
      'Abwasserleitungen stehen nicht unter Druck: Ein Leck zeigt sich nur, wenn Wasser abfließt, nach dem Duschen, einer Wäsche oder einer Spülung. Deshalb entgehen sie den Verfahren für Leitungen unter Druck. Expomis setzt die passenden Verfahren für Abwassernetze ein: Fluoreszein, Rauchtest und Kanalkamera.',
    ],
    sections: [
      {
        h2: 'Anzeichen für ein Leck im Abwasser',
        list: [
          'ein Fleck, der nach der Benutzung eines bestimmten Geräts erscheint oder größer wird;',
          'Kanalgeruch in einem Raum oder im Keller;',
          'Feuchtigkeit am Fuß eines Fallrohrs oder an einer Kellerwand;',
          'langsamer Abfluss oder wiederkehrender Rückstau;',
          'ein Absacken des Bodens über einer erdverlegten Leitung.',
        ],
      },
      {
        h2: 'Drei sich ergänzende Verfahren',
        list: [
          '[Fluoreszein](/de/leckortung-verfahren/fluoreszein): Das Wasser eines einzelnen Geräts wird eingefärbt, und man beobachtet, wo es wieder auftaucht. So weiß man, welches Gerät, welcher Abfluss betroffen ist.',
          '[Rauchtest](/de/leckortung-verfahren/rauchtest): Ein ungiftiger Rauch wird in das Netz geleitet und tritt an undichten Verbindungen und Rissen aus. Ideal bei Geruch.',
          '[Kanalkamera](/de/leckortung-verfahren/kanalkamera): Man sieht ins Rohr hinein, Risse, verschobene Muffen, Wurzeln, Verformungen, Gegengefälle.',
        ],
      },
      {
        h2: 'Erdverlegte Leitungen und Kanalanschluss',
        body: [
          'Unter einer Kellersohle oder im Garten lässt eine gerissene Abwasserleitung das Wasser im Boden versickern und kann mit der Zeit das Erdreich destabilisieren. Mit der Kanalkamera lässt sich der Schaden anhand der vom Schacht aus abgerollten Kabellänge bestimmen, sodass nur an der richtigen Stelle gegraben wird.',
        ],
      },
    ],
    faq: [
      {
        q: 'Kommt Kanalgeruch immer von einem Leck?',
        a: 'Nein. Ein ausgetrockneter Siphon (selten benutztes Gerät) oder eine fehlende Entlüftung können Gerüche aufsteigen lassen. Der Rauchtest zeigt genau, wo sie eintreten.',
      },
      {
        q: 'Ist Fluoreszein gefährlich?',
        a: 'Nein. Es ist ein ungiftiger Farbstoff, der in sehr geringer Konzentration eingesetzt wird und auch zur Markierung von Grundwasser dient.',
      },
    ],
    related: ['/de/leckortung-dusche', '/de/ortung-wassereintritt', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/leckortung-dusche',
    lang: 'de',
    translationOf: '/recherche-fuite-douche',
    parent: PARENT,
    nav: 'Leck an Dusche oder unter Fliesen',
    summary: 'Dusche, bodengleiche Dusche, Badewanne: Zuleitung, Ablauf oder Abdichtung?',
    title: 'Undichte Dusche, Badewanne, Leck unter Fliesen | Expomis',
    description: 'Undichte Dusche, bodengleiche Dusche oder Badewanne: Wir prüfen Zuleitung, Ablauf und Abdichtung getrennt, um die wirkliche Ursache zu finden, ohne Abriss.',
    eyebrow: 'Leckarten',
    h1: 'Undichte Dusche, Badewanne oder Leck unter Fliesen',
    serviceType: 'Leckortung',
    image: fluoresceineImg,
    imageAlt: 'Fluoreszein-Test unter UV-Licht: Das gefärbte Wasser zeigt ein Leck im Ablauf',
    intro: [
      'Ein Fleck an der Decke unter dem Bad, eine Fuge, die schwarz wird, eine Fliese, die hohl klingt: Die Dusche ist eine der häufigsten Leckquellen. Schwierig ist herauszufinden, woher das Wasser kommt, denn es gibt drei mögliche Ursachen, und jede erfordert eine andere Reparatur.',
    ],
    sections: [
      {
        h2: 'Drei mögliche Ursachen',
        list: [
          'Die Zuleitung: die Warm- oder Kaltwasserleitung zur Mischbatterie, in der Wand verlegt. Sie leckt ständig, auch wenn die Dusche nicht benutzt wird.',
          'Der Ablauf: Ablaufventil, Siphon, Anschluss an die Abwasserleitung. Er leckt nur, wenn Wasser abfließt.',
          'Die Abdichtung: Fugen, Duschwanne, Dichtbahn unter den Fliesen. Das Wasser dringt durch, wenn es an den Wänden herunterläuft oder am Boden steht.',
        ],
        after: [
          'Neue Fugen nützen nichts, wenn das Leck von der Zuleitung kommt. Ein neuer Siphon nützt nichts, wenn es an der Abdichtung liegt. Deshalb lohnt es sich, jede Ursache getrennt zu prüfen, bevor Arbeiten beginnen.',
        ],
      },
      {
        h2: 'Wie wir sie unterscheiden',
        list: [
          'Zuleitung: [Druckprüfung](/de/leckortung-verfahren/druckpruefung) der Leitungen und [Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera), um den Verlauf des Warmwassers zu verfolgen.',
          'Ablauf: Mit [Fluoreszein](/de/leckortung-verfahren/fluoreszein) gefärbtes Wasser wird nur in den Ablauf gegossen, ohne die Wände zu benetzen, und man beobachtet, ob es im Fleck wieder auftaucht.',
          'Abdichtung: Zone für Zone wird bewässert (Wände, Ecken, Wandfuß, Schwelle), und die Entwicklung der Feuchtigkeit wird mit dem [Feuchtigkeitsmessgerät](/de/leckortung-verfahren/feuchtigkeitsmessung) verfolgt.',
        ],
      },
      {
        h2: 'Der Sonderfall bodengleiche Dusche',
        body: [
          'Ohne Duschwanne hängt die Dichtheit einer bodengleichen Dusche ganz von der Abdichtung unter den Fliesen ab. Die Mängel liegen meist rund um den Bodenablauf, am Wandfuß und an der Schwelle. Diese Bereiche prüfen wir zuerst.',
        ],
      },
      {
        h2: 'In der Wohnung',
        body: [
          'Das Leck zeigt sich meist beim Nachbarn darunter. Unsere Prüfungen stellen fest, ob es wirklich aus Ihrem Bad kommt und von welchem Teil, was für die Bearbeitung des [Wasserschadens](/de/wasserschaden) unerlässlich ist.',
        ],
      },
    ],
    faq: [
      {
        q: 'Reicht es, die Fugen zu erneuern, um eine undichte Dusche zu reparieren?',
        a: 'Nur wenn das Wasser durch die Fugen dringt. Kommt das Leck von der Zuleitung, vom Ablauf oder von der Abdichtung unter den Fliesen, ändern neue Fugen nichts.',
      },
    ],
    related: ['/de/leckortung-abwasser', '/de/leckortung-wasserleitung', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/ortung-wassereintritt',
    lang: 'de',
    translationOf: '/recherche-infiltration',
    parent: PARENT,
    nav: 'Eindringendes Wasser',
    summary: 'Dach, Terrasse, Fassade, Keller: herausfinden, wo das Regenwasser eintritt.',
    title: 'Wassereintritt orten: Dach, Terrasse, Fassade, Keller | Expomis',
    description: 'Ortung von eindringendem Wasser über Dach, Terrasse, Fassade oder Keller: gezielte Bewässerung, Fluoreszein, Wärmebild, Feuchtigkeitsmessung.',
    eyebrow: 'Leckarten',
    h1: 'Wassereintritt orten: Dach, Terrasse, Fassade, Keller',
    serviceType: 'Ortung von Wassereintritten',
    image: humidimetreImg,
    imageAlt: 'Feuchtigkeitsmessung an einer Wand mit Wassereintritt',
    intro: [
      'Eindringendes Wasser ist kein Leitungsleck: Das Wasser kommt von außen, meist als Regen, und tritt durch einen Mangel an der Gebäudehülle ein. Es zeigt sich oft weit entfernt von der Eintrittsstelle und nur bei bestimmtem Wetter, was die Ortung schwierig macht. Expomis verfolgt den Weg des Wassers zurück, um die Eintrittsstelle zu finden.',
    ],
    sections: [
      {
        h2: 'Anzeichen für eindringendes Wasser',
        list: [
          'ein Fleck an der Decke unter einem Dach oder einer Terrasse, der nach Regen größer wird;',
          'Feuchtigkeit an einer Wand, die Schlagregen ausgesetzt ist, oder rund um ein Fenster;',
          'ein Keller, der nach einem Gewitter Wasser zieht;',
          'Spuren, die sich mit dem Wetter verändern statt mit dem Wasserverbrauch im Haus.',
        ],
      },
      {
        h2: 'Wassereintritt oder etwas anderes?',
        body: [
          'Ein Feuchtigkeitsfleck ist nicht unbedingt eindringendes Wasser. Ein Leitungsleck, Kondensation oder aufsteigende Feuchtigkeit verursachen ähnliche Symptome. Die Kartierung mit dem [Feuchtigkeitsmessgerät](/de/leckortung-verfahren/feuchtigkeitsmessung), der Zusammenhang mit dem Wetter und eine [Druckprüfung](/de/leckortung-verfahren/druckpruefung) der Leitungen in der Nähe schaffen Klarheit.',
        ],
      },
      {
        h2: 'Wie wir einen Wassereintritt orten',
        list: [
          'Gezielte Bewässerung: Ein genau abgegrenzter Bereich wird bewässert (ein Abdichtungsanschluss, ein Terrassenablauf, eine Schwelle, ein Fensterrahmen), und man beobachtet, ob das Wasser innen austritt. Mit [Fluoreszein](/de/leckortung-verfahren/fluoreszein) gefärbt, ist es eindeutig zu erkennen.',
          '[Wärmebildkamera](/de/leckortung-verfahren/waermebildkamera): Feuchte Bereiche einer Decke oder einer Dämmung erscheinen kälter, was die Ausdehnung und den Weg des Wassers sichtbar macht.',
          '[Endoskopie](/de/leckortung-verfahren/endoskopie): um in eine abgehängte Decke, eine Vorsatzschale oder einen Hohlraum zu sehen, ohne abzubauen.',
        ],
      },
      {
        h2: 'Flachdächer und Terrassen',
        body: [
          'Auf einem Flachdach oder einer Terrasse tritt das Wasser selten mitten in der Fläche ein. Die Schwachstellen liegen an den Anschlüssen an die Wände, rund um die Abläufe, an Fugen und an den Schwellen von Terrassentüren. Wir prüfen diese Bereiche einzeln, um den undichten zu finden.',
        ],
      },
    ],
    faq: [
      {
        q: 'Muss man auf Regen warten, um einen Wassereintritt zu finden?',
        a: 'Nein. Wir stellen den Wasserzulauf durch gezielte Bewässerung Zone für Zone nach, sodass sich die Eintrittsstelle auch bei trockenem Wetter finden lässt.',
      },
    ],
    related: ['/de/leckortung-abwasser', '/de/leckortung-dusche', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/hoher-wasserverbrauch',
    lang: 'de',
    translationOf: '/surconsommation-eau',
    parent: PARENT,
    nav: 'Hoher Wasserverbrauch',
    summary: 'Auffällige Rechnung, Zähler, der sich dreht: das Leck finden, das keine Spuren hinterlässt.',
    title: 'Hoher Wasserverbrauch, Wasserzähler läuft | Leck finden | Expomis',
    description: 'Auffällige Wasserrechnung oder Wasserzähler, der bei geschlossenen Hähnen läuft? Was Sie selbst prüfen können, dann die Ortung des verdeckten Lecks ohne Abriss.',
    eyebrow: 'Leckarten',
    h1: 'Hoher Wasserverbrauch: das verdeckte Leck finden',
    serviceType: 'Leckortung',
    intro: [
      'Eine Wasserrechnung, die ohne veränderte Gewohnheiten stark steigt, ein Zähler, der sich dreht, obwohl alles geschlossen ist: Irgendwo entweicht Wasser, manchmal ohne sichtbare Spur, weil es direkt in einen Abfluss oder ins Erdreich läuft.',
    ],
    sections: [
      {
        h2: 'Selbst prüfen in 30 Minuten',
        ordered: true,
        list: [
          'Schließen Sie alle Hähne und schalten Sie die Geräte ab, die Wasser verbrauchen (Waschmaschine, Spülmaschine, Enthärtungsanlage, Bewässerung).',
          'Notieren Sie den Zählerstand, oder beobachten Sie das kleine Sternrad, das sich bei jedem Durchfluss dreht.',
          'Warten Sie 30 Minuten, ohne Wasser zu benutzen, und lesen Sie erneut ab.',
          'Hat sich der Zählerstand verändert, gibt es ein Leck hinter dem Zähler.',
        ],
        after: [
          'Bevor Sie uns anrufen, prüfen Sie die häufigsten unsichtbaren Lecks: einen Spülkasten, der ständig in die Schüssel nachläuft (einige Tropfen Farbstoff im Spülkasten zeigen es), eine Sicherheitsgruppe am Warmwasserspeicher, die in den Abfluss tropft, eine Enthärtungsanlage, die in der Regeneration hängt, einen Außenwasserhahn.',
        ],
      },
      {
        h2: 'Wenn diese Prüfungen nichts ergeben',
        body: [
          'Dann liegt das Leck wahrscheinlich an einer [Unterputz- oder Erdleitung](/de/leckortung-wasserleitung). Wir sperren die Kreisläufe einzeln ab und prüfen sie [unter Druck](/de/leckortung-verfahren/druckpruefung), um zu wissen, welcher Wasser verliert, und orten dann die Leckstelle [akustisch](/de/leckortung-verfahren/akustische-ortung) oder mit [Tracergas](/de/leckortung-verfahren/tracergas).',
        ],
      },
      {
        h2: 'Ihre Rechnung',
        body: [
          'Manche Versorger oder Gemeinden gewähren einen Nachlass auf die Rechnung, wenn ein verdecktes Leck geortet und repariert wurde. Erkundigen Sie sich bei Ihrem: Unser Bericht dokumentiert das Leck und seine Lage.',
        ],
      },
    ],
    faq: [
      {
        q: 'Erstattet meine Versicherung das verlorene Wasser?',
        a: 'Selten. Die Verträge decken in der Regel die durch Wasser verursachten Schäden und oft die Kosten der Leckortung, seltener den verlorenen Verbrauch. Prüfen Sie Ihre Bedingungen.',
      },
    ],
    related: ['/de/leckortung-wasserleitung', '/de/leckortung-heizung', '/de/leckortung-luxemburg'],
  },
  {
    path: '/de/wasserschaden',
    lang: 'de',
    translationOf: '/degat-des-eaux',
    nav: 'Wasserschaden',
    summary: 'Die Ursache des Wassers finden und den Schaden für die Versicherung dokumentieren.',
    serviceType: 'Gutachten bei Wasserschäden',
    areaServed: AREAS.lu,
    title: 'Wasserschaden in Luxemburg: Ursache, Versicherung | Expomis',
    description: 'Nach einem Wasserschaden: erste Schritte, Ursachensuche, Schadensbewertung und Unterlagen für die Versicherung. Expomis übernimmt Leckortung und Gutachten.',
    eyebrow: 'Schadensgutachten',
    h1: 'Wasserschaden: die Ursache finden und den Schaden dokumentieren',
    intro: [
      'Nach einem Wasserschaden stellen sich zwei Fragen: Woher kommt das Wasser, und wer übernimmt die Schäden? Expomis beantwortet beide, denn wir führen sowohl die [Leckortung](/de/leckortung-luxemburg) als auch das Schadensgutachten durch.',
    ],
    sections: [
      {
        h2: 'Die ersten Schritte',
        ordered: true,
        list: [
          'Stoppen Sie den Wasserzulauf: Schließen Sie den Hauptwasserhahn oder das Absperrventil des betroffenen Geräts.',
          'Schalten Sie den Strom in den betroffenen Räumen ab, wenn das Wasser Steckdosen oder Geräten nahekommt.',
          'Fotografieren Sie die Schäden, bevor Sie etwas verschieben oder reinigen.',
          'Informieren Sie Ihre Versicherung innerhalb der im Vertrag vorgesehenen Frist, und Ihren Nachbarn oder die Hausverwaltung, wenn andere Wohnungen betroffen sind.',
          'Bewahren Sie beschädigte Gegenstände bis zur Begutachtung auf.',
        ],
      },
      {
        h2: 'Warum die Ursache so wichtig ist',
        body: [
          'Die Kostenübernahme hängt oft davon ab, woher das Wasser kommt: private Leitung, Gemeinschaftseigentum des Gebäudes, Nachbarwohnung, Wassereintritt über das Dach, Rückstau aus dem Kanal. Jeder Fall kann unter einen anderen Vertrag fallen oder einen anderen Verantwortlichen haben. Solange die Ursache nicht genau feststeht, kann die Bearbeitung ins Stocken geraten. Unser Ratgeber [Wasserschaden in Luxemburg: Wer zahlt?](/de/wasserschaden-wer-zahlt) erklärt jeden Fall.',
          'Deshalb orten wir zuerst das Leck, mit zerstörungsfreien Verfahren, bevor wir die Schäden bewerten.',
        ],
      },
      {
        h2: 'Was wir tun',
        list: [
          'Ortung des [Lecks](/de/leckortung-luxemburg) oder des [Wassereintritts](/de/ortung-wassereintritt);',
          'Feststellung der Schäden: Fotos, Feuchtigkeitsmessungen, Ausdehnung der betroffenen Zone;',
          'Bericht innerhalb von 72 Stunden, den Sie an Ihre Versicherung weiterleiten können;',
          'Schadensgutachten, im Auftrag einer Versicherungsgesellschaft oder als unabhängiges Gegengutachten an Ihrer Seite.',
        ],
      },
    ],
    faq: [
      {
        q: 'Wer bezahlt die Leckortung?',
        a: 'In vielen Fällen übernimmt die Gebäude- oder Hausratversicherung die Kosten der Leckortung, wenn das Leck einen Wasserschaden verursacht hat. Bedingungen und Höchstbeträge sind unterschiedlich: Prüfen Sie Ihren Vertrag. Mieter, Miteigentum, Nachbar: siehe unseren Ratgeber [Wasserschaden: Wer zahlt?](/de/wasserschaden-wer-zahlt).',
      },
      {
        q: 'Muss ich vor der Reparatur auf den Gutachter warten?',
        a: 'Treffen Sie sofort die dringenden Maßnahmen, um das Leck zu stoppen und den Schaden zu begrenzen: Das wird von Ihnen erwartet. Informieren Sie vor endgültigen Reparaturen zuerst Ihre Versicherung und bewahren Sie Fotos des Zustands vor den Arbeiten auf.',
      },
    ],
    related: ['/de/wasserschaden-wer-zahlt', '/de/leckortung-luxemburg', '/de/leckortung-dusche'],
  },
  {
    path: '/de/wasserschaden-wer-zahlt',
    lang: 'de',
    translationOf: '/fuite-eau-qui-paie',
    parent: '/de/wasserschaden',
    guide: { datePublished: '2026-10-14' },
    nav: 'Wasserschaden: Wer zahlt?',
    summary: 'Mieter, Vermieter, Miteigentum, Nachbar, öffentliches Netz: wer für das Leck und die Schäden aufkommt.',
    areaServed: AREAS.lu,
    title: 'Wasserschaden in Luxemburg: Wer zahlt? Ratgeber | Expomis',
    description: 'Leck oder Wasserschaden in Luxemburg: Wer zahlt Reparatur, Schäden und Leckortung? Mieter, Vermieter, Miteigentum, Nachbar, Wasserzähler, Neubau.',
    eyebrow: 'Ratgeber — Oktober 2026',
    h1: 'Wasserschaden in Luxemburg: Wer zahlt?',
    intro: [
      'Nach einem Wasserleck fallen drei Kosten an: die Suche nach dem Leck, die Reparatur dessen, was undicht ist, und die Behebung der Schäden, die das Wasser verursacht hat. Sie müssen nicht von derselben Person getragen werden. Wer zahlt, hängt vor allem von einer Tatsache ab: wo genau das Leck liegt.',
      'Dieser Ratgeber stellt die allgemeinen Regeln vor, denen wir als [Leckorter](/de/leckortung-luxemburg) und Schadensgutachter in Luxemburg begegnen. Er ist keine Rechtsberatung: Maßgeblich sind Ihr Versicherungsvertrag, Ihr Mietvertrag und die Teilungserklärung des Gebäudes. Bei Streitigkeiten wenden Sie sich an Ihre Versicherung, Ihre Rechtsschutzversicherung oder einen Anwalt.',
    ],
    sections: [
      {
        h2: 'Kurz gesagt',
        list: [
          'Eigenes Haus, selbst bewohnt: Sie zahlen die Reparatur; Ihre Hausversicherung deckt in der Regel den Wasserschaden und oft die Kosten der Leckortung.',
          'Mietwohnung: Kleine Instandhaltungsreparaturen trägt grundsätzlich der Mieter, Reparaturen an Leitungen und Installation der Vermieter, außer bei Verschulden oder mangelnder Pflege durch den Mieter.',
          'Miteigentum (copropriété): Ein Leck am Gemeinschaftseigentum ist Sache der Eigentümergemeinschaft, vertreten durch die Hausverwaltung (Syndic); ein Leck am Sondereigentum Sache des betroffenen Eigentümers.',
          'Leck beim Nachbarn: Ihre Schäden werden in der Regel von Ihrer eigenen Versicherung ersetzt, die sich dann an den Verantwortlichen halten kann.',
          'Leck vor dem Wasserzähler: in der Regel öffentliches Netz (Gemeinde oder Wassersyndikat); nach dem Zähler der Eigentümer.',
          'Neubau oder kürzlich renoviert: Das Leck kann unter die Gewährleistung des Bauträgers oder der Firmen fallen.',
        ],
        after: [
          'In jedem Fall zeigt erst die genaue Ortung des Lecks, welcher Fall vorliegt.',
        ],
      },
      {
        h2: 'Warum alles davon abhängt, wo das Leck liegt',
        body: [
          'Derselbe Fleck an der Decke kann von einer privaten Leitung kommen, von einem gemeinsamen Steigstrang des Gebäudes, von der Dusche des Nachbarn, vom Dach oder von einem Rückstau aus dem Kanal. Jede dieser Ursachen bedeutet einen anderen Verantwortlichen und einen anderen Versicherungsvertrag. Solange die Ursache nicht feststeht, kann jeder die Kosten auf den anderen schieben, und die Schadensbearbeitung stockt.',
          'Deshalb ist ein Leckortungsbericht, der die Ursache mit Fotos und Messwerten belegt, oft das erste Dokument, das Versicherungen verlangen.',
        ],
      },
      {
        h2: 'Sie sind Eigentümer Ihres Hauses',
        body: [
          'Die Reparatur der Installation (Leitung, Verbindung, Heizung, Abfluss) tragen Sie: Es ist Ihr Eigentum. Die durch das Wasser verursachten Schäden (Decken, Wände, Böden, Möbel) deckt in der Regel Ihre Hausversicherung als Wasserschaden, gemäß Ihren Vertragsbedingungen.',
          'Viele Verträge übernehmen auch die Kosten der Leckortung, wenn ein Leck einen Wasserschaden verursacht hat, oft bis zu einem Höchstbetrag. Seltener decken sie die Reparatur der Leitung selbst, und selten das verlorene Wasser.',
        ],
      },
      {
        h2: 'Sie sind Mieter oder Vermieter',
        body: [
          'Der Grundsatz: Der Mieter übernimmt die laufende Pflege und kleine Reparaturen (Dichtungen, Schläuche, Armaturen, Reinigen der Siphons), der Vermieter die größeren Reparaturen an der Installation (Unterputzleitungen, Heizung, Abwasserleitungen). Ein Leck an einer Unterputzleitung ist daher in der Regel Sache des Vermieters, außer es beruht auf einem Verschulden oder mangelnder Pflege des Mieters.',
          'Der Mieter muss den Vermieter unverzüglich informieren: Wer ein Leck schlimmer werden lässt, ohne etwas zu sagen, kann dafür haften. Mietverträge verlangen oft, dass der Mieter eine Mieterhaftpflichtversicherung abschließt; sie kann für seine Sachen und seine Haftung aufkommen. Die Versicherung des Vermieters deckt in der Regel das Gebäude.',
          'Wer beauftragt die Leckortung? Mieter, Vermieter oder Hausverwaltung können das tun. Am einfachsten ist es, sich vorher abzustimmen: Der Bericht, der die Ursache des Lecks feststellt, dient anschließend zur Aufteilung der Kosten.',
        ],
      },
      {
        h2: 'Sie wohnen in einem Gebäude in Miteigentum',
        body: [
          'Die Teilungserklärung (règlement de copropriété) unterscheidet das Sondereigentum jedes Eigentümers vom Gemeinschaftseigentum aller. In der Regel gehören die Steigstränge für Wasser und Abwasser, das Dach und die Fassade zum Gemeinschaftseigentum, während die Leitungen, die nur eine Wohnung versorgen, hinter deren Absperrventil zum Sondereigentum zählen. Die genaue Grenze legt aber die Teilungserklärung Ihres Gebäudes fest.',
          'Ein Leck am Gemeinschaftseigentum geht zulasten der Eigentümergemeinschaft: Informieren Sie die Hausverwaltung, die die Gebäudeversicherung einschaltet. Ein Leck am Sondereigentum ist Sache des betroffenen Eigentümers und seiner Versicherung.',
        ],
      },
      {
        h2: 'Das Wasser kommt vom Nachbarn',
        body: [
          'Melden Sie den Schaden Ihrer eigenen Versicherung: In der Regel entschädigt sie Sie gemäß Ihrem Vertrag und hält sich dann gegebenenfalls an den Verantwortlichen oder dessen Versicherung. Informieren Sie auch den Nachbarn und, in einem Gebäude in Miteigentum, die Hausverwaltung.',
          'Um das Leck zu orten, braucht es Zugang zu der Wohnung, aus der es kommt. Bestreitet der Nachbar die Ursache, stellt der Leckortungsbericht die Tatsachen fest.',
        ],
      },
      {
        h2: 'Vor oder nach dem Wasserzähler',
        body: [
          'In der Regel gehört der Hausanschluss bis zum Zähler zum öffentlichen Netz (Gemeinde oder Wassersyndikat), alles nach dem Zähler ist Sache des Eigentümers. Die genaue Grenze und die Kostenregeln legt das Reglement Ihrer Gemeinde fest: Erkundigen Sie sich bei deren Wasserdienst.',
          'Bei einem verdeckten Leck nach dem Zähler gewähren manche Gemeinden einen Nachlass auf die Wasserrechnung, sobald das Leck geortet und repariert ist. Siehe unsere Seite [hoher Wasserverbrauch](/de/hoher-wasserverbrauch).',
        ],
      },
      {
        h2: 'Neubau oder kürzlich renoviert',
        body: [
          'Ist die Wohnung neu, kann das Leck unter die Gewährleistung des Bauträgers oder der Firmen fallen, die gebaut oder renoviert haben: zweijährige oder zehnjährige Gewährleistung, je nach betroffenem Bauteil. Informieren Sie sie schriftlich, und lassen Sie die Ursache des Lecks dokumentieren, bevor es repariert wird, damit die Beweise nicht verloren gehen.',
        ],
      },
      {
        h2: 'Eindringendes Wasser und Rückstau',
        body: [
          '[Eindringendes Wasser](/de/ortung-wassereintritt) über Dach, Terrasse oder Fassade ist in der Regel Sache des Gebäudeeigentümers oder, bei Miteigentum, der Eigentümergemeinschaft. Ein Rückstau aus dem Kanal kann je nach Ursprung dem öffentlichen Netz oder der privaten Installation zuzurechnen sein. Versicherungsverträge behandeln diese Fälle sehr unterschiedlich, manche schließen sie aus: Prüfen Sie Ihre Bedingungen.',
        ],
      },
      {
        h2: 'Wenn Sie mit der Entschädigung nicht einverstanden sind',
        body: [
          'Erscheint Ihnen die Bewertung des Gutachters Ihrer Versicherung zu niedrig, oder die festgestellte Ursache falsch, können Sie einen eigenen Gutachter beauftragen. Dieses Gegengutachten ist in den meisten Verträgen vorgesehen.',
        ],
      },
    ],
    faq: [
      {
        q: 'Wer zahlt die Leckortung?',
        a: 'In der Regel streckt sie vor, wer sie beauftragt. Oft erstattet die Hausversicherung sie, wenn das Leck einen Wasserschaden verursacht hat, bis zu einem Höchstbetrag. Bei Miete oder Miteigentum können die Kosten anschließend nach der im Bericht festgestellten Ursache aufgeteilt werden.',
      },
      {
        q: 'Ersetzt meine Versicherung das verlorene Wasser?',
        a: 'Selten. Die Verträge decken vor allem die durch Wasser verursachten Schäden. Manche Gemeinden gewähren jedoch einen Nachlass auf die Rechnung, nachdem ein verdecktes Leck geortet und repariert wurde.',
      },
      {
        q: 'Ich bin Mieter: Muss ich die Reparatur des Lecks bezahlen?',
        a: 'Nicht, wenn es eine Unterputzleitung oder einen wichtigen Teil der Installation betrifft, außer bei Verschulden oder mangelnder Pflege Ihrerseits. Kleine Reparaturen (Dichtungen, Schläuche, Armaturen) tragen grundsätzlich Sie. Ihr Mietvertrag kann die Aufteilung genauer regeln.',
      },
      {
        q: 'Der Nachbar oben verweigert den Zugang für die Leckortung. Was tun?',
        a: 'Informieren Sie Ihre Versicherung und, bei Miteigentum, die Hausverwaltung, die sich an ihn wenden können. Dokumentieren Sie die Schäden bei Ihnen mit Fotos und Messwerten. Hält die Blockade an, lassen Sie sich von Ihrer Versicherung oder einem Anwalt beraten.',
      },
      {
        q: 'Muss ich mit der Reparatur auf den Gutachter warten?',
        a: 'Treffen Sie sofort die dringenden Maßnahmen, um das Leck zu stoppen und den Schaden zu begrenzen. Informieren Sie vor endgültigen Reparaturen zuerst Ihre Versicherung und bewahren Sie Fotos des Zustands vor den Arbeiten auf.',
      },
    ],
    related: ['/de/wasserschaden', '/de/leckortung-luxemburg', '/de/leckortung-wasserleitung'],
  },  {
    path: '/de/leckortung-kosten',
    lang: 'de',
    translationOf: '/prix-recherche-fuite',
    parent: PARENT,
    nav: 'Kosten einer Leckortung',
    summary: 'Im Voraus festgelegter Preis für jede Leistung, Pauschale bei einfacher Leckortung möglich.',
    title: 'Kosten einer Leckortung in Luxemburg | Expomis',
    description: 'Was kostet eine Leckortung in Luxemburg? Im Voraus festgelegter Preis pro Leistung, Pauschale bei einfacher Ortung, Kostenübernahme durch die Versicherung.',
    eyebrow: 'Preise',
    h1: 'Kosten einer Leckortung in Luxemburg',
    intro: [
      'Bei Expomis wird eine Leckortung pro Leistung abgerechnet, zu einem im Voraus festgelegten Preis. Sie beschreiben uns die Situation, wir erklären Ihnen, wie wir vorgehen würden, und nennen Ihnen den Preis vor dem Einsatz. Wird das Leck bei einem einzigen Besuch und ohne Abbau gefunden, gilt eine Pauschale, wenn sie für Sie günstiger ist.',
    ],
    sections: [
      {
        h2: 'Ein Preis, der vor dem Einsatz feststeht',
        body: [
          'Der Preis wird vor Beginn der Arbeiten mit Ihnen vereinbart, auf Grundlage Ihrer Beschreibung. Sie wissen, was Sie zahlen, und können den Preis Ihrer Versicherung oder Hausverwaltung vorlegen, bevor Sie zustimmen.',
          'Wir veröffentlichen keinen Einheitspreis, weil keine Leckortung der anderen gleicht. Ein Fleck unter einer Dusche in einer Wohnung und ein Druckverlust an einer Fußbodenheizung von 150 m² erfordern weder denselben Zeitaufwand noch dieselben Geräte. Ein veröffentlichter Preis wäre für den ersten Fall zu hoch oder für den zweiten irreführend.',
        ],
      },
      {
        h2: 'Die Pauschale für eine einfache Leckortung',
        body: [
          'Eine Leckortung ist einfach, wenn das Leck bei einem einzigen Besuch gefunden wird, ohne dass für die Prüfungen etwas abgebaut werden muss. In diesem Fall kann eine Pauschale gelten.',
          'Wir rechnen nach dem ersten Besuch: Ist die Pauschale für Sie günstiger als der Preis der Leistung, wird die Pauschale angewendet.',
        ],
      },
      {
        h2: 'Wovon der Preis abhängt',
        list: [
          'von der Art des Leitungsnetzes: Eine Druckleitung, eine [Abwasserleitung](/de/leckortung-abwasser) oder [eindringendes Wasser](/de/ortung-wassereintritt) werden nicht auf dieselbe Weise geortet;',
          'von der Zahl der zu prüfenden Kreisläufe: Kaltwasser, Warmwasser, Heizung, Heizkreise einer Fußbodenheizung;',
          'von der Größe des Gebäudes: Wohnung, Haus, Mehrfamilienhaus mit Gemeinschaftsteilen;',
          'von den nötigen [Verfahren](/de/leckortung-verfahren): [Tracergas](/de/leckortung-verfahren/tracergas) oder eine [Kamerainspektion](/de/leckortung-verfahren/kanalkamera) erfordern mehr Vorbereitung als eine Feuchtigkeitsmessung;',
          'vom Zugang zu den Installationen: Schächte, abgehängte Decken, Installationsschächte, Verteiler.',
        ],
      },
      {
        h2: 'Was wir für einen Preis brauchen',
        list: [
          'die Art der Immobilie und das Stockwerk, und ob es sich um Miteigentum handelt;',
          'was Sie feststellen, und seit wann: Fleck, Zähler, der sich dreht, Heizung, die Druck verliert, Geruch;',
          'einige Fotos der betroffenen Zone, und des Zählers, wenn Sie ihn verdächtigen;',
          'was bereits unternommen wurde: Besuch eines Installateurs, Öffnung, Meldung an die Versicherung.',
        ],
        after: ['Sie können uns diese Angaben über das [Kontaktformular](/de/kontakt) senden oder uns anrufen.'],
      },
      {
        h2: 'Wer zahlt die Leckortung?',
        body: [
          'In Luxemburg übernehmen viele Gebäude- und Hausratversicherungen die Kosten der Leckortung, wenn das Leck einen Wasserschaden verursacht hat, oft bis zu einem Höchstbetrag. Prüfen Sie Ihren Vertrag oder fragen Sie Ihren Versicherungsagenten. Unser Bericht ist das Dokument, das die Versicherung zur Bearbeitung des Schadens erwartet.',
          'Mieter, Eigentümer, Miteigentum, Nachbar: Die Aufteilung hängt davon ab, wo das Leck liegt. Unser Ratgeber [Wasserschaden in Luxemburg: Wer zahlt?](/de/wasserschaden-wer-zahlt) erklärt jeden Fall.',
        ],
      },
    ],
    faq: [
      {
        q: 'Was kostet eine Leckortung in Luxemburg?',
        a: 'Der Preis hängt von der Situation ab: Art des Lecks, Zahl der zu prüfenden Kreisläufe, nötige Verfahren. Er wird vor dem Einsatz mit Ihnen festgelegt. Wird das Leck bei einem einzigen Besuch und ohne Abbau gefunden, wenden wir eine Pauschale an, wenn sie für Sie günstiger ist. Beschreiben Sie uns die Situation, um einen Preis zu erhalten.',
      },
      {
        q: 'Warum veröffentlichen Sie keinen Preis?',
        a: 'Weil er nur für einen Teil der Fälle stimmen würde. Wir nennen Ihnen lieber vor dem Einsatz den Preis, der zu Ihrer Situation passt.',
      },
      {
        q: 'Übernimmt die Versicherung die Leckortung?',
        a: 'Oft, wenn das Leck einen Wasserschaden verursacht hat, im Rahmen der Höchstbeträge Ihres Vertrags. Mit dem im Voraus festgelegten Preis können Sie vor dem Einsatz bei Ihrer Versicherung nachfragen.',
      },
    ],
    related: ['/de/wasserschaden-wer-zahlt', '/de/wasserschaden', '/de/leckortung-luxemburg'],
  },
];
